import React, { useEffect, useState } from "react";
import { ENTREGAS } from "../../data/entregas";
import Estrellas from "./Estrellas";

/**
 * Comentarios reales de clientes, en el home.
 *
 * Salen de /.netlify/functions/testimonios: los que el cliente autorizó
 * publicar desde su página de entrega, con 4 o 5 estrellas. Llegan con el
 * nombre ya recortado ("Yaneida G.") y el tipo de evento sin fecha ("boda"),
 * nunca con el enlace de la entrega. Se muestran tal como los escribió el
 * cliente: corregirle la ortografía sería poner palabras en su boca.
 *
 * Sin comentarios —o si la función falla, o en `npm start`, que no ejecuta
 * funciones— la sección no se dibuja: una sección de opiniones vacía resta.
 */

const ENDPOINT = "/.netlify/functions/testimonios";

/* "boda" -> "Boda civil", desde las mismas entregas que arman las páginas. */
const TITULO_EVENTO = Object.fromEntries(
  ENTREGAS.map((entrega) => [
    entrega.path.replace("/entregas/", "").replace(/-\d{2}-\d{2}-\d{4}$/, ""),
    entrega.titulo,
  ])
);

const tituloEvento = (evento) => {
  if (!evento) return "";
  if (TITULO_EVENTO[evento]) return TITULO_EVENTO[evento];
  const texto = evento.replace(/-/g, " ");
  return texto.charAt(0).toUpperCase() + texto.slice(1);
};

const conMayuscula = (texto) => texto.charAt(0).toUpperCase() + texto.slice(1);

const FotoComentarios = () => {
  const [testimonios, setTestimonios] = useState([]);

  useEffect(() => {
    let vigente = true;
    fetch(ENDPOINT)
      .then((response) => (response.ok ? response.json() : { testimonios: [] }))
      .then((data) => {
        if (vigente && Array.isArray(data.testimonios)) setTestimonios(data.testimonios);
      })
      .catch(() => {});
    return () => {
      vigente = false;
    };
  }, []);

  if (testimonios.length === 0) return null;

  return (
    <section id="comentarios" className="bg-sand-50 py-14 md:py-16">
      <div className="container-omega">
        <h2 className="font-display text-2xl font-bold tracking-tight text-navy-900 md:text-3xl">
          Lo que dicen nuestros clientes
        </h2>
        <ul
          className={`mt-8 grid gap-4 ${
            testimonios.length === 1 ? "max-w-2xl" : "sm:grid-cols-2 lg:grid-cols-3"
          }`}
        >
          {testimonios.map((t) => (
            <li key={t.id} className="surface-card flex flex-col p-6">
              <Estrellas n={t.estrellas} />
              <blockquote className="mt-4 flex-grow">
                <p className="line-clamp-6 leading-relaxed text-navy-700">“{conMayuscula(t.comentario)}”</p>
              </blockquote>
              <p className="mt-5 text-sm">
                <span className="font-semibold text-navy-900">{t.nombre}</span>
                {t.evento ? <span className="text-navy-500"> · {tituloEvento(t.evento)}</span> : null}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FotoComentarios;
